<template>
    <div v-if="series">
        <CardRowLink
            v-if="series.partnersOverviewLink"
            :label="$t('partners-overview')"
            :link-target="series.partnersOverviewLink"
            :link-text="valueToString(series.partnersOverviewName)"
            :has-border-bottom="true"
        />
        <CardRowText
            v-else
            :label="$t('partners-overview')"
            :text="valueToString(series.partnersOverviewName)"
            :has-border-bottom="true"
        />
        <CardRowAttachmentGroup
            v-if="organizers.length"
            :label="$t('organizers')"
            :items="organizers"
            :has-border-bottom="true"
        />
        <CardRowText v-else :label="$t('organizers')" text="-" :has-border-bottom="true" />
        <CardRowAttachmentGroup
            v-if="executors.length"
            :label="$t('executors')"
            :items="executors"
            :has-border-bottom="true"
        />
        <CardRowText v-else :label="$t('executors')" text="-" :has-border-bottom="true" />
        <CardRowAttachmentGroup
            v-if="sponsors.length"
            :label="$t('sponsors')"
            :items="sponsors"
            :has-border-bottom="true"
        />
        <CardRowText v-else :label="$t('sponsors')" text="-" :has-border-bottom="true" />
        <CardRowText
            :label="$t('additional-partners')"
            :text="valueToString(series.additionalPartners)"
            :has-border-bottom="false"
        />
    </div>
</template>
<script setup lang="ts">
import CardRowAttachmentGroup from '@/components/Card/CardRowAttachmentGroup.vue';
import CardRowLink from '@/components/Card/CardRowLink.vue';
import CardRowText from '@/components/Card/CardRowText.vue';
import { toCardRowAttachmentLink } from '@/components/MultiLink/multilink';
import { useEventSeries } from '@/event/composables/useEventSeries';
import { valueToString } from '@/forms/forms';
import { computed } from 'vue';

const props = defineProps<{ seriesId: string }>();

const seriesId = computed(() => props.seriesId);
const { series } = useEventSeries(seriesId);

const organizers = computed(() => toCardRowAttachmentLink(series.value?.organizers?.links?.nodes));
const executors = computed(() => toCardRowAttachmentLink(series.value?.executors?.links?.nodes));
const sponsors = computed(() => toCardRowAttachmentLink(series.value?.sponsors?.links?.nodes));
</script>
